function getUrlParam(name) {
    let match = RegExp('[?&]' + name + '=([^&]*)').exec(window.location.search);
    return match && match[1] && decodeURIComponent(match[1].replace(/\+/g, ' '));
}

export function filteredName (val) {
    val = val.replace(/[^А-Яа-яІіЇїҐґЄє'‎\u2018\u2019‎ -]/g, "");
    return val.replace(/[\u2018\u2019‎]/g, "'");
}

let forbiddenWords = [
    'підпис', 'агент', 'представник', 'представитель', 'неопр',
    'контакт', 'керівник', 'фоп', 'тов', 'канцелярія',
    'канцелярия', 'пат', 'спд', 'доверенность', 'довіреність',
    'тест', 'бухгалтер', 'магазин', 'персонал'
];
let wrongPattern = /(.)\1{2}|^['-]{1}|['-]{1}$|['-]{2}/;

export function isWrongFullName(fullName) {
    let words = fullName.toLowerCase().split(/[\s,]+/);
    let uniqueWords = words.filter((v, i, a) => a.indexOf(v) === i);
    if (words.length < 2 || words.length > 5 || (words.length !== uniqueWords.length))
        return true;
    return words.some(isWrongName);
}
export function isWrongName (name) {
    let word = name.toLowerCase().trim();
    if (!(/^[А-яІіЇїҐґЄє' -]+$/.test(name))
        || forbiddenWords.indexOf(word) >= 0
        || wrongPattern.test(word)
    ) {
        return true;
    }
    return false;
}

let Profile = {
    username: "",
    otptype: 'email',// null, // sms || email
    challenge: getUrlParam("login_challenge"),
    otpcode: "",
    otpsend: false,
    registration: false,
    pincode: '',
    sanswer: '',
    squestion: null,
    stips: null,
    slanguage: 'uk',
    squestionList: {},
    lastName: '',
    firstName: '',
    middleName: '',
    language: 'uk',
    process: 'login',//login || accessRecovery || registration
    birthdayDate: null,
    registerQuestion: '',
    registerAnswer: '',
    registerAnswerLang: 'uk',
    registerTip: '',
    redirectTo: null,
    recoveryContacts: {},
    recoveryMethod: '',
    needsetphone: false,
    needsetemail: false,
    needsetpincode: false,
    needsetquestion: false,
    secondOTP: {
        username: '',
        otpcode: '',
        otptype: null,
        otpsend: false
    },
    thirdOTP: {
        username: '',
        otpcode: '',
        otptype: null,
        otpsend: false
    },


    setData: function (data) {
        for (let key in data) {
            let item = data[key];
            this[key] = typeof item === "string" ? item.trim() : item;
        }
    },

    getDeviceId: function () {
        return !this.username ? "" : localStorage.getItem(this.username);
    },

    setDeviceId: function (id) {
        if (this.username)
            localStorage.setItem(this.username, id);
    },

    reset: function () {
       this.setData({
           username: "",
           otptype: null,
           // challenge: getUrlParam("login_challenge"),
           otpcode: "",
           otpsend: false,
           registration: false,
           pincode: '',
           sanswer: '',
           squestion: null,
           stips: null,
           slanguage: '',
           squestionList: {},
           lastName: '',
           firstName: '',
           middleName: '',
           // language: 'uk',
           process: 'login',//login || accessRecovery || registration
           birthdayDate: null,
           registerQuestion: '',
           registerAnswer: '',
           // registerAnswerLang: 'uk',
           registerTip: '',
           redirectTo: null,
           recoveryContacts: {},
           recoveryMethod: '',
           needsetphone: false,
           needsetemail: false,
           needsetpincode: false,
           needsetquestion: false,
           secondOTP: {
               username: '',
               otpcode: '',
               otptype: null,
               otpsend: false
           },
           thirdOTP: {
               username: '',
               otpcode: '',
               otptype: null,
               otpsend: false
           },
       });
    },
};
window.Profile = Profile;
export default Profile;